import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const WagesCheckContainer = styled.div`
    width:100%;
    .container{
        width:100%;
        height:100%;
      .container2 {
        width: 100%;
        height: 100%;
        .ant-row{
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
       
        .text{
          font-size:14px;
          color: darkgray;
        }
        
      }
        .font14{
            font-size:14px;
        }
        .height50{
            height:50px;
        }
        &>.hang1{
            width:100%;

            .icon{
                font-size:25px;
                color:#008ae6;
            }

            .wxts{
                color:#f71f1f;
                line-height:25px;
            }
        }

        &>.pickerBox{
            width:100%;
        }
        &>.pickerListBox{
            width:100%;

            .itemBox{
                height:50px;
            }
        }
        .am-list-body div:not(:last-child) .am-list-line {
            border-bottom: 1px solid #ddd;
        }
        .am-list-item{
            padding-left: 15px;
            padding-right: 15px;
            .am-list-line{
                padding-right: 0px;
            }
        }
    }

`
